import {getUrlFromOption} from '../apps/aife/aife-menu'

export const isUrlActive = (url, path) => {
    if (!url) return false;
    const windowLocationPath = (path || window.location.pathname).replace(/\//g, '');
    const urlToMatch = encodeURIComponent(url.replace(/\//g, ''))
    return encodeURIComponent(windowLocationPath).endsWith(encodeURIComponent(urlToMatch));
};
export const isOptionActive = (option, path) =>
    isUrlActive(getUrlFromOption(option.name || option, path));
